// extracted by mini-css-extract-plugin
export default {"content":"ResourceContentTemplate_content__QPNQj"};